<template>
  <div id="greeting">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex sm4 xs12>
          <div class="headline">Greeting</div>
        </v-flex>
        <v-flex sm3 xs6>
          <!-- <v-autocomplete
            :items="users"
            clearable
            item-text="phone"
            item-value="phone"
            label="User"
            v-model="searchPhone"
          ></v-autocomplete>-->
        </v-flex>
        <v-flex sm3 xs6>
          <v-autocomplete
            :items="regions"
            clearable
            item-text="nametha"
            item-value="idx"
            label="Region"
            v-model="searchRegion"
          ></v-autocomplete>
        </v-flex>

        <v-flex sm2 text-xs-center xs12>
          <GreetingDialog />
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            :headers="headers"
            :items="filterStates"
            :loading="tableLoading"
            class="elevation-0"
            disable-initial-sort
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item.idx)">
                <td>{{ props.item.idx }}</td>
                <td>{{ props.item.greetingText || '-' }}</td>
                <td>{{ filterWeekDay(props.item.weekDay) }}</td>
                <td>{{ filterRegion(props.item.regionId) || '-' }}</td>
                <td>{{ props.item.startTime ? props.item.startTime.slice(0, 5) : '-' }}</td>
                <td>{{ props.item.endTime ? props.item.endTime.slice(0, 5) : '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'

import GreetingDialog from '@/components/admin/GreetingDialog'
export default {
  name: 'greeting',
  components: {
    GreetingDialog
  },
  data() {
    return {
      searchRegion: '',
      // Table
      tableLoading: false,
      headers: [
        { text: 'ID', align: 'left', value: 'idx', width: '10' },
        { text: 'Text', align: 'left', value: 'greetingText', width: '200' },
        { text: 'Week Day', align: 'left', value: 'weekDay', width: '300' },
        { text: 'Region', align: 'left', value: 'regionId', width: '300' },
        { text: 'Date', align: 'left', value: 'startTime', width: '100' },
        { text: 'Time', align: 'left', value: 'endTime', width: '100' }
      ],
      weekDays: [
        {
          idx: 1,
          name: 'อาทิตย์ (Sunday)'
        },
        {
          idx: 2,
          name: 'จันทร์ (Monday)'
        },
        {
          idx: 3,
          name: 'อังคาร (Tuesday)'
        },
        {
          idx: 4,
          name: 'พุธ (Wednesday)'
        },
        {
          idx: 5,
          name: 'พฤหัส (Thursday)'
        },
        {
          idx: 6,
          name: 'ศุกร์ (Firday)'
        },
        {
          idx: 7,
          name: 'เสาร์ (Saturday)'
        }
      ]
    }
  },
  beforeRouteEnter: (to, from, next) => {
    store.state.Greeting.data.length === 0 // main fetch
      ? store.dispatch('Greeting/fetch').then(next())
      : next()

    if (store.state.Types.data.length === 0) store.dispatch('Types/fetch')
  },
  computed: {
    filterStates() {
      if (this.searchRegion) {
        return this.states.filter(item => item.regionId == this.searchRegion)
      } else {
        return this.states
      }
    },
    states() {
      return this.$store.getters['Greeting/getAll']
    },
    regions() {
      return this.$store.getters['Place/getRegionAll']
    }
  },
  created() {},
  methods: {
    filterWeekDay(weekDay) {
      let res = this.weekDays
        .filter(item => item.idx == weekDay)
        .map(item => item.name)
        .toString()
      return res
    },
    filterRegion(regionId) {
      let res = this.regions
        .filter(item => item.idx == regionId)
        .map(item => item.nametha)
        .toString()
      return res
    },
    editItem(idx) {
      this.$store.commit('Greeting/UPDATE_DIALOG', true)
      this.$store.commit('Greeting/SET_IDX', idx)
    }
  }
}
</script>

<style lang="scss" scoped></style>
